var _path, _path2, _path3;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import { forwardRef } from "react";

const SvgArrowGoBack10 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.64268 14.3455V23H5.07489V15.871H5.02418L3 17.1641V15.7274L5.15096 14.3455H6.64268Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9681 23.1649C10.2722 23.1649 9.67499 22.9888 9.17634 22.6366C8.6805 22.2816 8.29877 21.7703 8.03113 21.1026C7.76631 20.4321 7.6339 19.625 7.6339 18.6812C7.63672 17.7374 7.77054 16.9345 8.03536 16.2725C8.30299 15.6076 8.68473 15.1005 9.18056 14.7512C9.67921 14.4018 10.2751 14.2272 10.9681 14.2272C11.6611 14.2272 12.257 14.4018 12.7556 14.7512C13.2543 15.1005 13.636 15.6076 13.9008 16.2725C14.1685 16.9374 14.3023 17.7403 14.3023 18.6812C14.3023 19.6278 14.1685 20.4364 13.9008 21.1069C13.636 21.7745 13.2543 22.2845 12.7556 22.6366C12.2598 22.9888 11.664 23.1649 10.9681 23.1649ZM10.9681 21.8422C11.509 21.8422 11.9358 21.5759 12.2485 21.0435C12.5641 20.5082 12.7218 19.7208 12.7218 18.6812C12.7218 17.9938 12.65 17.4163 12.5063 16.9486C12.3626 16.481 12.1598 16.1288 11.8978 15.8922C11.6358 15.6527 11.3259 15.533 10.9681 15.533C10.43 15.533 10.0046 15.8006 9.69189 16.3359C9.37918 16.8683 9.22141 17.6501 9.21859 18.6812C9.21578 19.3714 9.2848 19.9518 9.42566 20.4223C9.56934 20.8927 9.77218 21.2477 10.0342 21.4872C10.2962 21.7238 10.6075 21.8422 10.9681 21.8422Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9 7H14C15.5913 7 17.1174 7.63214 18.2426 8.75736C19.3679 9.88258 20 11.4087 20 13C20 14.5913 19.3679 16.1174 18.2426 17.2426C18.1637 17.3216 18.0828 17.3981 18 17.4721V19.9282C18.6004 19.5816 19.1582 19.1556 19.6569 18.6569C21.1571 17.1566 22 15.1217 22 13C22 10.8783 21.1571 8.84344 19.6569 7.34315C18.1566 5.84285 16.1217 5 14 5H9V1L3 6L9 11V7Z"
  })));
};

const ForwardRef = /*#__PURE__*/forwardRef(SvgArrowGoBack10);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/arrow-go-back-10.e03554bf2c15905b12390123fd984edd.svg";